/**
 * 적 — 잡몹/네임드 스폰 + 사천왕/마왕 고정 배치. 프로토타입 이식.
 */
import { BOSSES, DEMON_KING, SPAWN, WORLD } from '@villager/shared';
import { colX, rowZ } from './coords.js';
import type { Enemy } from './state.js';
import type { World } from './sim.js';

/** 사천왕 4 + 마왕 생성. */
export function initBossesAndKing(w: World): void {
  for (const b of BOSSES) {
    const x = colX(b.col);
    const z = rowZ(b.row);
    w.bosses.push({
      id: w.nextId(),
      name: b.name,
      pos: { x, z },
      hp: b.hp,
      maxhp: b.hp,
      pow: b.pow,
      named: false,
      boss: true,
      king: false,
      dead: false,
      col: b.col,
      row: b.row,
    });
  }
  w.demonKing = {
    id: w.nextId(),
    name: DEMON_KING.name,
    pos: { x: 0, z: rowZ(0) + 4 },
    hp: DEMON_KING.hp,
    maxhp: DEMON_KING.hp,
    pow: DEMON_KING.pow,
    named: false,
    boss: true,
    king: true,
    dead: false,
    col: 0,
    row: 0,
  };
}

const MOB_ADJ = ['검은', '굶주린', '외눈', '가시'];
const MOB_NOUN = ['늑대', '오우거', '살쾡이', '골렘'];

/**
 * 잡몹/네임드 1기 스폰 (마왕령 = row < frontRow).
 * 압축 보정(지시서 3.4): 마왕령이 좁아질수록 개체의 "격"이 오른다.
 * (개체 "수" 상한은 World.step 에서 함께 줄인다 — 양↓ 격↑)
 */
export function spawnMob(w: World): void {
  const ratio = w.frontRow / WORLD.FRONT_ROW_INIT; // 1(초기) → 0.25(최대 압축)
  const quality = 1 + (1 - ratio) * SPAWN.COMPRESSION_QUALITY;

  const named = w.rng.chance(Math.min(0.5, 0.14 * quality));
  const r = w.rng.int(w.frontRow);
  const c = w.rng.int(WORLD.GW);
  const x = colX(c) + (w.rng.next() - 0.5) * WORLD.TILE * 0.6;
  const z = rowZ(r) + (w.rng.next() - 0.5) * WORLD.TILE * 0.6;
  const depth = 1 - r / Math.max(1, w.frontRow);
  const hp = Math.round((named ? 95 : 36) * quality);
  const mob: Enemy = {
    id: w.nextId(),
    name: named ? `${w.rng.pick(MOB_ADJ)}${w.rng.pick(MOB_NOUN)}` : '잡몹',
    pos: { x, z },
    hp,
    maxhp: hp,
    pow: (named ? 1.7 : 1) * (12 + depth * 30) * quality,
    named,
    boss: false,
    king: false,
    dead: false,
    col: c,
    row: r,
  };
  w.mobs.push(mob);
}
